import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  max-width: 936px;
  margin: 12px auto 0 auto;
`;

export const WrapperHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 16px;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const WrapperTooltip = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start !important;

  span {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #4f6168;
  }

  @media (min-width: 768px) {
    justify-content: flex-end !important;
  }
`;

export const WrapperMain = styled.div`
  margin-top: 8px;

  > div:first-child {
    @media (max-width: 640px) {
      justify-content: flex-end;
    }
  }
`;
